const REQUIRED_ACTION_ROUTE_MAP = {
  reset_password: "/account/password-reset",
  update_license_number: "/account/md-card-input",
  upload_profile: "/account/doctor-file-upload",
  upload_signature: "/account/doctor-e-signature",
  register_success: "/account/staff-register-success",
};

export function getRequiredActionRoute(requiredAction) {
  if (!requiredAction) {
    return null;
  }

  return REQUIRED_ACTION_ROUTE_MAP[requiredAction] ?? null;
}
